var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGuestMaybeAttending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_help_24px",
    d: "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Zm.6,10.2H7.4V11H8.6ZM9.842,7.55,9.3,8.1a2.043,2.043,0,0,0-.7,1.7H7.4V9.5a2.415,2.415,0,0,1,.7-1.7l.744-.756A1.173,1.173,0,0,0,9.2,6.2a1.2,1.2,0,0,0-2.4,0H5.6a2.4,2.4,0,1,1,4.8,0A1.909,1.909,0,0,1,9.842,7.55Z",
    transform: "translate(-2 -2)",
    fill: "#ecb269"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGuestMaybeAttending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-guest-maybe-attending.199d8a824aa235e82fcc4d9bb8bbb52d.svg";